export const editorialItems = [
        {
            date: '2024-Present',
            title:'Associate Editor',
            text:'IEEE Transactions on Network Science and Engineering'
        },
        {
            date: '2023-2024',
            title:'Guest Editor',
            text:'ACM Transactions on Autonomous and Adaptive Systems, Special Issue: Intelligent Applications of Web 3.0 and Metaverse for Connected Autonomous Vehicles'
        },
        {
            date: '2022-2023',
            title:'Guest Editor',
            text:'IEEE Networking Letters, Special Issue: Networking Enablers for 6G Use Cases'
        },
        {
            date: '2021-2022',
            title:'Guest Editor',
            text:'IEEE Communications Magazine, Special Issue: Wireless Energy Transfer in Future Networks'
        },
        {
            date: '2020-Present',
            title:'Associate Editor',
            text:'IEEE Internet of Things Journal'
        },
        {
            date: '2019-Present',
            title:'Associate Editor',
            text:'Elsevier Vehicular Communications'
        },
        {
            date: '2018-Present',
            title:'Associate Editor',
            text:'IEEE Networking Letters'
        },
        {
            date: '2018',
            title:'Guest Editor',
            text:'Sensors Journal, Special Issue on Realization of Large-Scale Mobile Crowd Sensing Experiments'
        },
        {
            date: '2018',
            title:'Guest Editor',
            text:'Elsevier Sustainable Cities and Society, Special Issue on Smart Embedded Devices'
        },
        {
            date: '2018',
            title:'Guest Editor',
            text:'Sensors Journal, Sensors Journal, Special Issue on Emerging Algorithms and Applications in Vision Sensors System based on Artificial Intelligence'
        },
        {
            date: '2017-2018',
            title:'Steering Committee Member',
            text:'IEEE Transactions on Cloud Computing'
        },
        {
            date: '2017-2018',
            title:'Guest editor',
            text:'Elsevier Computer Communications, Special Issue on Energy-aware Design for Sustainable 5G Networks'
        },
        {
            date: '2017-Present',
            title:'Associate Editor',
            text:'IEEE Access'
        },
        {
            date: '2016-2021',
            title:'Area Editor',
            text:'IEEE Transactions on Green Communications and Networking'
        },
        {
            date: '2015-Present',
            title:'Editor',
            text:'IEEE Communications Surveys and Tutorials'
        },
        {
            date: '2015-2016',
            title:'Guest Editor',
            text:'IEEE Access Special Issue on Advances in Vehicular Clouds'
        },
        {
            date: '2015-2016',
            title:'Guest Editor',
            text:'IEEE Transactions on Cloud Computing - Special Issue on Mobile Clouds'
        },
        {
            date: '2013-2020',
            title:'Area Editor',
            text:'IEEE Ad Hoc and Sensor Networks Technical Committee Newsletter'
        },
         

    ];